import React from "react";
import PropTypes from "prop-types";
import axios from "axios";


class SendMessage extends React.Component {
  state = {
    message: "",
    loading: false
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.chatroomId !== nextProps.chatroomId){
      this.setState({ message: "" });
    }
  };

  render() {
    return (
      <div className="sender-box">
        <div>
          <label htmlFor="send-message" className="sr-only">Send Message</label>
          <textarea
            className="form-control"
            id="send-message"
            aria-labelledby="send-message"
            value={this.state.message}
            onChange={this.handlerChangeMessage}
            disabled={this.props.loading}
          />
        </div>
        <a
          className="btn btn-pink btn-block btn-raised"
          disabled={this.props.loading}
          onClick={this.send}
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && this.send()}
        >
          SEND
        </a>
      </div>
    );
  }

  handlerChangeMessage = (e) => this.setState({message: e.target.value});

  send = () => {
    if(this.state.loading) { return; }
    this.setState({loading: true});

    axios.post(`/chatrooms/${this.props.chatroomId}/messages`, {
      content: this.state.message
    }).then(({data}) => {
      this.setState({loading: false, message: ""});
      this.props.onSent(data);
    }).catch(({response}) => {
      this.setState({loading: false});
      toastr.error(response.data.errors.join(". "));
    });
  };
}

SendMessage.propTypes = {
  chatroomId: PropTypes.number,
  onSent: PropTypes.func,
  loading: PropTypes.bool
};

export default SendMessage;
